import React from 'react';
import Aboutus from './Component/Aboutus';
//import Gallerycard from './Component/Gallerycard';
import ProductCard from './Component/ProductCard';
import Slider from './Component/Slider';
import Navbar from './Component/Navbar';
import Footer from './Component/Footer';
const Home = () =>{
    return(
        <>
        <Navbar/>
        <Slider/>
        <Aboutus/>
        <ProductCard/>
        <Footer/>
        </>
    );
};

export default Home;